import React from "react";

function RefundPolicy() {
  return (
    <div className="bg-gray-100 min-h-screen py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-2xl p-8 md:p-12">
        
        {/* Heading */}
        <div className="border-b pb-6 mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
            Refund Policy
          </h1>
          <p className="text-gray-500 mt-2">
            Please review our refund and cancellation terms carefully.
          </p>
        </div>

        {/* Content Section */}
        <div className="space-y-6 text-gray-700 leading-relaxed text-[16px] md:text-lg">
          
          <div className="bg-blue-50 border-l-4 border-blue-500 p-5 rounded-md">
            <p>
              If an event is canceled or postponed by <strong>Family Fun AZ</strong> 
              or the <strong>Arizona Boardwalk</strong>, the Vendor/Sponsor is 
              eligible to receive a credit toward a future event date.
            </p>
          </div>

          <div className="bg-gray-100 p-6 rounded-xl">
            <p className="mb-4">
              If a Vendor/Sponsor is unable to attend an event, a 
              <strong> 7-day notice </strong> is required to receive a credit 
              toward a future event date.
            </p>

            <p>
              If a Vendor/Sponsor cancels within the 7-day period before an 
              event or does not show on the day of the event, no credit will 
              be extended. The credit will be forfeited due to lack of advance 
              notice. We do not provide refunds if a Vendor cancels an event.
            </p>
          </div>

        </div>

      </div>
    </div>
  );
}

export default RefundPolicy;